import PropTypes from 'prop-types';
import React from "react";

class SelectionPane extends React.Component {
    static displayName = 'Pane';

    static propTypes = {
        label: PropTypes.string.isRequired,
        invisible: PropTypes.bool,
        children: PropTypes.element.isRequired
    };

    render() {
        return (<div className={this.props.styleClass?this.props.styleClass:""}>{this.props.children}</div>);
    }
}

export default SelectionPane;


// WEBPACK FOOTER //
// ./src/components/common/SelectionPane.js